import React, { useState } from "react";

import PropTypes from "prop-types";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { SystemEditIcon16 } from "../../icons/SystemIcons";

import { archiveTag, activateTag } from "../../../lib/api/admin";

export const SingleTag = ({
  name,
  selected,
  clickHandler,
  fetchActiveTags,
  fetchArchivedTags,
  setOldTagName,
  setModalType,
  setOpen,
  setTagToRename,
  activeTags,
  archivedTags,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleActivateTag = async (name) => {
    await activateTag({ name });
    await fetchActiveTags();
    await fetchArchivedTags();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRename = (name) => {
    setModalType("rename");
    setOpen(true);
    setAnchorEl(null);
    setTagToRename(name);
    setOldTagName(name);
  };

  const handleArchive = async (name) => {
    setAnchorEl(null);
    await archiveTag({ name: name });
    await fetchActiveTags();
    await fetchArchivedTags();
  };

  const handleSelect = (name) => {
    if (!activeTags || !archivedTags) {
      clickHandler(name);
    } else {
      return;
    }
  };

  return (
    <div
      className={selected ? "other-tag other-tag--selected" : "other-tag"}
      onClick={() => handleSelect(name)}
    >
      {name}
      {activeTags && (
        <button
          className="edit"
          aria-controls="edit-menu"
          aria-haspopup="true"
          onClick={handleClick}
        >
          <SystemEditIcon16 />
          Edit
        </button>
      )}
      {archivedTags && (
        <button
          className="edit"
          aria-controls="edit-menu"
          aria-haspopup="true"
          onClick={() => handleActivateTag(name)}
        >
          Activate
        </button>
      )}

      <Menu
        id="edit-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => handleRename(name)}>Rename</MenuItem>
        <MenuItem onClick={() => handleArchive(name)}>Archive</MenuItem>
      </Menu>
    </div>
  );
};

SingleTag.propTypes = {
  name: PropTypes.string,
  selected: PropTypes.bool,
  clickHandler: PropTypes.func,
  fetchActiveTags: PropTypes.func,
  fetchArchivedTags: PropTypes.func,
  setOldTagName: PropTypes.func,
  setModalType: PropTypes.func,
  setOpen: PropTypes.func,
  setTagToRename: PropTypes.func,
  activeTags: PropTypes.object,
  archivedTags: PropTypes.object,
};
